// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";

const useShowMyListDetailsCategoryView = () => {
    const showMyListDetailCategoryView = useAppSelector(
        state => toToolkitApplicationState(state).bunzl.pages.myListDetailsCategory.showCategoryView,
    );
    return showMyListDetailCategoryView;
};

export default useShowMyListDetailsCategoryView;
